import { useEffect, useState } from "react"
import { Link } from "react-router-dom";

import { useFirebase } from "@meddbriefer/mdb-firebase"

import { deleteDocument } from "@meddbriefer/scenario-data"

const COLLECTION_ID = "scenario-types"

export default function ScenarioTypeList(props) {
    const {db} = useFirebase()
    const [scenarioTypes, setScenarioTypes] = useState(null)

    useEffect(
        () => {
            (async () => {
                const cursor = await db.collection(COLLECTION_ID).get()
                let scenTypes = []
                cursor.forEach(doc => {
                    const data = doc.data()
                    scenTypes.push({
                        id: doc.id,
                        name: data.name,
                        schemaVersion: data.schemaVersion
                    })
                })
                setScenarioTypes(scenTypes)
            })()
        },
        [db]
    )

    const handleDelete = async (item) => {
        let id = item.id;
        if (window.confirm('Are you sure you want to permanently this item? This cannot be undone!')) {
            await deleteDocument(db, COLLECTION_ID, id);
            let dup = scenarioTypes.slice();
            dup.splice(dup.indexOf(item), 1);
            setScenarioTypes(dup);
        } else
            console.log(`Delete of ${item.name} cancelled.`);
    }

    if (!scenarioTypes) {
        return (<div>Loading...</div>)
    }
    return (
        <div className="db-list">
            <h2>Scenario Types</h2>

            <Link
                to={`/scenario-type`}
                className="new-bttn db-list-item"
            >
                <h2>New Scenario Type</h2>
            </Link>

            {scenarioTypes.map(st =>
                <div
                    key={st.id}
                    className="db-list-item"
                >
                    <h2>{st.name}</h2>
                    <div className="list-button-wrapper">
                        <Link
                            to={`/scenario-type/${st.id}`}
                            className="action-bttn"
                        >
                            Edit
                        </Link>
                        <button
                            type="button"
                            className="action-bttn delete-bttn"
                            onClick={() => handleDelete(st)}
                        >
                            Delete
                        </button>
                    </div>

                </div>
            )}
        </div>
    )
}
